import FunnelRatioChartWrap from "./ClickImpressionActionChart/FunnelRatio/FunnelRatioChartWrap"
import ImpressionShareChartWrap from "./ClickImpressionActionChart/ImpressionShare/ImpressionShareChartWrap"
import ClickImpressionActionSortWrap from "./ClickImpressionActionSortWrap"


const ClickImpressionAction = () => {
  return (
    <>
      <ClickImpressionActionSortWrap/>
      <ImpressionShareChartWrap/>
      <FunnelRatioChartWrap/>
    </>
  )
}

export default ClickImpressionAction